import { render, staticRenderFns } from "./MultipleUpload.vue?vue&type=template&id=cfb25dbc&scoped=true&"
import script from "./MultipleUpload.vue?vue&type=script&lang=js&"
export * from "./MultipleUpload.vue?vue&type=script&lang=js&"
import style0 from "./MultipleUpload.vue?vue&type=style&index=0&id=cfb25dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb25dbc",
  null
  
)

export default component.exports